import React from "react";
import ChooseUsChard from "./ChooseUsChard";
import { Container, Row, Col } from "react-bootstrap";

const WhyChooseUs = () => {
	return (
		<Container style={{ marginBottom: "2rem", padding: "50px 20px" }}>
			<h4
				style={{ color: "black" }}
				className="text-uppercase  Ethnocentric why-choose-heading"
			>
				Why Choose Us?
			</h4>
			<Row className="g-4">
				<Col lg={4} md={6} sm={12} xs={12} className="d-flex justify-content-center">
					<ChooseUsChard
						title={"24/7 Operational Exellence"}
						image_path={"/assets/images/24-hours-support.png"}
						description={`Our logistics network runs seamlessly 24 hours a day to ensure timely, 
                dependable delivery-whenever our clients need us.`}
					/>
				</Col>
				<Col lg={4} md={6} sm={12} xs={12} className="d-flex justify-content-center">
					<ChooseUsChard
						title={"Precision & Speed"}
						image_path={"/assets/images/deadline.png"}
						description={`We deliver with urgency and accuracy,
                 maintaining high standards across every shipment to ensure reliability and performance.`}
					/>
				</Col>
				<Col lg={4} md={6} sm={12} xs={12} className="d-flex justify-content-center">
					<ChooseUsChard
						title={"Client-Centric Service"}
						image_path={"/assets/images/customer-centricity.png"}
						description={`We prioritize client satisfaction by offering responsive support, tailored solutions, 
                and a consistently smooth delivery experience.`}
					/>
				</Col>
			</Row>
		</Container>
	);
};

export default WhyChooseUs;
